/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminLayoutRouteImport } from './routes/admin/layout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ParticipateLayoutRouteImport } from './routes/participate/layout'
import { Route as SessionLayoutRouteImport } from './routes/session/layout'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as UserLayoutRouteImport } from './routes/user/layout'
import { Route as AdminOrganization_idRouteImport } from './routes/admin/$organization_id'
import { Route as ParticipateDoneRouteImport } from './routes/participate/done'
import { Route as ParticipateSetupRouteImport } from './routes/participate/setup'
import { Route as ParticipateSession_tokenIndexRouteImport } from './routes/participate/$session_token/index'
import { Route as ParticipateSession_tokenJoinRouteImport } from './routes/participate/$session_token/join'
import { Route as ParticipateSession_tokenLobbyRouteImport } from './routes/participate/$session_token/lobby'
import { Route as SessionSession_tokenIndexRouteImport } from './routes/session/$session_token/index'
import { Route as SessionSession_tokenResultsSplatRouteImport } from './routes/session/$session_token/results/$'

const AdminIndexLazyRouteImport = createFileRoute('/admin/')()
const SessionIndexLazyRouteImport = createFileRoute('/session/')()
const UserUser_idLazyRouteImport = createFileRoute('/user/$user_id')()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLayoutRoute = AdminLayoutRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ParticipateLayoutRoute = ParticipateLayoutRouteImport.update({
  id: '/participate',
  path: '/participate',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionLayoutRoute = SessionLayoutRouteImport.update({
  id: '/session',
  path: '/session',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const UserLayoutRoute = UserLayoutRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexLazyRoute = AdminIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutRoute,
} as any).lazy(() => import('./routes/admin/index.lazy').then((d) => d.Route))
const AdminOrganization_idRoute = AdminOrganization_idRouteImport.update({
  id: '/$organization_id',
  path: '/$organization_id',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const ParticipateDoneRoute = ParticipateDoneRouteImport.update({
  id: '/done',
  path: '/done',
  getParentRoute: () => ParticipateLayoutRoute,
} as any)
const ParticipateSetupRoute = ParticipateSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => ParticipateLayoutRoute,
} as any)
const SessionIndexLazyRoute = SessionIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SessionLayoutRoute,
} as any).lazy(() => import('./routes/session/index.lazy').then((d) => d.Route))
const UserUser_idLazyRoute = UserUser_idLazyRouteImport.update({
  id: '/$user_id',
  path: '/$user_id',
  getParentRoute: () => UserLayoutRoute,
} as any).lazy(() => import('./routes/user/$user_id.lazy').then((d) => d.Route))
const ParticipateSession_tokenIndexRoute =
  ParticipateSession_tokenIndexRouteImport.update({
    id: '/$session_token/',
    path: '/$session_token/',
    getParentRoute: () => ParticipateLayoutRoute,
  } as any)
const ParticipateSession_tokenJoinRoute =
  ParticipateSession_tokenJoinRouteImport.update({
    id: '/$session_token/join',
    path: '/$session_token/join',
    getParentRoute: () => ParticipateLayoutRoute,
  } as any)
const ParticipateSession_tokenLobbyRoute =
  ParticipateSession_tokenLobbyRouteImport.update({
    id: '/$session_token/lobby',
    path: '/$session_token/lobby',
    getParentRoute: () => ParticipateLayoutRoute,
  } as any)
const SessionSession_tokenIndexRoute =
  SessionSession_tokenIndexRouteImport.update({
    id: '/$session_token/',
    path: '/$session_token/',
    getParentRoute: () => SessionLayoutRoute,
  } as any)
const SessionSession_tokenResultsSplatRoute =
  SessionSession_tokenResultsSplatRouteImport.update({
    id: '/$session_token/results/$',
    path: '/$session_token/results/$',
    getParentRoute: () => SessionLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminLayoutRouteWithChildren
  '/participate': typeof ParticipateLayoutRouteWithChildren
  '/session': typeof SessionLayoutRouteWithChildren
  '/user': typeof UserLayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/admin/$organization_id': typeof AdminOrganization_idRoute
  '/participate/done': typeof ParticipateDoneRoute
  '/participate/setup': typeof ParticipateSetupRoute
  '/user/$user_id': typeof UserUser_idLazyRoute
  '/admin/': typeof AdminIndexLazyRoute
  '/session/': typeof SessionIndexLazyRoute
  '/participate/$session_token/join': typeof ParticipateSession_tokenJoinRoute
  '/participate/$session_token/lobby': typeof ParticipateSession_tokenLobbyRoute
  '/participate/$session_token/': typeof ParticipateSession_tokenIndexRoute
  '/session/$session_token/': typeof SessionSession_tokenIndexRoute
  '/session/$session_token/results/$': typeof SessionSession_tokenResultsSplatRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/participate': typeof ParticipateLayoutRouteWithChildren
  '/user': typeof UserLayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/admin/$organization_id': typeof AdminOrganization_idRoute
  '/participate/done': typeof ParticipateDoneRoute
  '/participate/setup': typeof ParticipateSetupRoute
  '/user/$user_id': typeof UserUser_idLazyRoute
  '/admin': typeof AdminIndexLazyRoute
  '/session': typeof SessionIndexLazyRoute
  '/participate/$session_token/join': typeof ParticipateSession_tokenJoinRoute
  '/participate/$session_token/lobby': typeof ParticipateSession_tokenLobbyRoute
  '/participate/$session_token': typeof ParticipateSession_tokenIndexRoute
  '/session/$session_token': typeof SessionSession_tokenIndexRoute
  '/session/$session_token/results/$': typeof SessionSession_tokenResultsSplatRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminLayoutRouteWithChildren
  '/participate': typeof ParticipateLayoutRouteWithChildren
  '/session': typeof SessionLayoutRouteWithChildren
  '/user': typeof UserLayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/admin/$organization_id': typeof AdminOrganization_idRoute
  '/participate/done': typeof ParticipateDoneRoute
  '/participate/setup': typeof ParticipateSetupRoute
  '/user/$user_id': typeof UserUser_idLazyRoute
  '/admin/': typeof AdminIndexLazyRoute
  '/session/': typeof SessionIndexLazyRoute
  '/participate/$session_token/join': typeof ParticipateSession_tokenJoinRoute
  '/participate/$session_token/lobby': typeof ParticipateSession_tokenLobbyRoute
  '/participate/$session_token/': typeof ParticipateSession_tokenIndexRoute
  '/session/$session_token/': typeof SessionSession_tokenIndexRoute
  '/session/$session_token/results/$': typeof SessionSession_tokenResultsSplatRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/participate'
    | '/session'
    | '/user'
    | '/login'
    | '/signup'
    | '/admin/$organization_id'
    | '/participate/done'
    | '/participate/setup'
    | '/user/$user_id'
    | '/admin/'
    | '/session/'
    | '/participate/$session_token/join'
    | '/participate/$session_token/lobby'
    | '/participate/$session_token/'
    | '/session/$session_token/'
    | '/session/$session_token/results/$'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/participate'
    | '/user'
    | '/login'
    | '/signup'
    | '/admin/$organization_id'
    | '/participate/done'
    | '/participate/setup'
    | '/user/$user_id'
    | '/admin'
    | '/session'
    | '/participate/$session_token/join'
    | '/participate/$session_token/lobby'
    | '/participate/$session_token'
    | '/session/$session_token'
    | '/session/$session_token/results/$'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/participate'
    | '/session'
    | '/user'
    | '/login'
    | '/signup'
    | '/admin/$organization_id'
    | '/participate/done'
    | '/participate/setup'
    | '/user/$user_id'
    | '/admin/'
    | '/session/'
    | '/participate/$session_token/join'
    | '/participate/$session_token/lobby'
    | '/participate/$session_token/'
    | '/session/$session_token/'
    | '/session/$session_token/results/$'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminLayoutRoute: typeof AdminLayoutRouteWithChildren
  ParticipateLayoutRoute: typeof ParticipateLayoutRouteWithChildren
  SessionLayoutRoute: typeof SessionLayoutRouteWithChildren
  UserLayoutRoute: typeof UserLayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/participate': {
      id: '/participate'
      path: '/participate'
      fullPath: '/participate'
      preLoaderRoute: typeof ParticipateLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session': {
      id: '/session'
      path: '/session'
      fullPath: '/session'
      preLoaderRoute: typeof SessionLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexLazyRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/$organization_id': {
      id: '/admin/$organization_id'
      path: '/$organization_id'
      fullPath: '/admin/$organization_id'
      preLoaderRoute: typeof AdminOrganization_idRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/participate/done': {
      id: '/participate/done'
      path: '/done'
      fullPath: '/participate/done'
      preLoaderRoute: typeof ParticipateDoneRouteImport
      parentRoute: typeof ParticipateLayoutRoute
    }
    '/participate/setup': {
      id: '/participate/setup'
      path: '/setup'
      fullPath: '/participate/setup'
      preLoaderRoute: typeof ParticipateSetupRouteImport
      parentRoute: typeof ParticipateLayoutRoute
    }
    '/session/': {
      id: '/session/'
      path: '/'
      fullPath: '/session/'
      preLoaderRoute: typeof SessionIndexLazyRouteImport
      parentRoute: typeof SessionLayoutRoute
    }
    '/user/$user_id': {
      id: '/user/$user_id'
      path: '/$user_id'
      fullPath: '/user/$user_id'
      preLoaderRoute: typeof UserUser_idLazyRouteImport
      parentRoute: typeof UserLayoutRoute
    }
    '/participate/$session_token/': {
      id: '/participate/$session_token/'
      path: '/$session_token'
      fullPath: '/participate/$session_token/'
      preLoaderRoute: typeof ParticipateSession_tokenIndexRouteImport
      parentRoute: typeof ParticipateLayoutRoute
    }
    '/participate/$session_token/join': {
      id: '/participate/$session_token/join'
      path: '/$session_token/join'
      fullPath: '/participate/$session_token/join'
      preLoaderRoute: typeof ParticipateSession_tokenJoinRouteImport
      parentRoute: typeof ParticipateLayoutRoute
    }
    '/participate/$session_token/lobby': {
      id: '/participate/$session_token/lobby'
      path: '/$session_token/lobby'
      fullPath: '/participate/$session_token/lobby'
      preLoaderRoute: typeof ParticipateSession_tokenLobbyRouteImport
      parentRoute: typeof ParticipateLayoutRoute
    }
    '/session/$session_token/': {
      id: '/session/$session_token/'
      path: '/$session_token'
      fullPath: '/session/$session_token/'
      preLoaderRoute: typeof SessionSession_tokenIndexRouteImport
      parentRoute: typeof SessionLayoutRoute
    }
    '/session/$session_token/results/$': {
      id: '/session/$session_token/results/$'
      path: '/$session_token/results/$'
      fullPath: '/session/$session_token/results/$'
      preLoaderRoute: typeof SessionSession_tokenResultsSplatRouteImport
      parentRoute: typeof SessionLayoutRoute
    }
  }
}

interface AdminLayoutRouteChildren {
  AdminOrganization_idRoute: typeof AdminOrganization_idRoute
  AdminIndexLazyRoute: typeof AdminIndexLazyRoute
}

const AdminLayoutRouteChildren: AdminLayoutRouteChildren = {
  AdminOrganization_idRoute: AdminOrganization_idRoute,
  AdminIndexLazyRoute: AdminIndexLazyRoute,
}

const AdminLayoutRouteWithChildren = AdminLayoutRoute._addFileChildren(
  AdminLayoutRouteChildren,
)

interface ParticipateLayoutRouteChildren {
  ParticipateDoneRoute: typeof ParticipateDoneRoute
  ParticipateSetupRoute: typeof ParticipateSetupRoute
  ParticipateSession_tokenJoinRoute: typeof ParticipateSession_tokenJoinRoute
  ParticipateSession_tokenLobbyRoute: typeof ParticipateSession_tokenLobbyRoute
  ParticipateSession_tokenIndexRoute: typeof ParticipateSession_tokenIndexRoute
}

const ParticipateLayoutRouteChildren: ParticipateLayoutRouteChildren = {
  ParticipateDoneRoute: ParticipateDoneRoute,
  ParticipateSetupRoute: ParticipateSetupRoute,
  ParticipateSession_tokenJoinRoute: ParticipateSession_tokenJoinRoute,
  ParticipateSession_tokenLobbyRoute: ParticipateSession_tokenLobbyRoute,
  ParticipateSession_tokenIndexRoute: ParticipateSession_tokenIndexRoute,
}

const ParticipateLayoutRouteWithChildren =
  ParticipateLayoutRoute._addFileChildren(ParticipateLayoutRouteChildren)

interface SessionLayoutRouteChildren {
  SessionIndexLazyRoute: typeof SessionIndexLazyRoute
  SessionSession_tokenIndexRoute: typeof SessionSession_tokenIndexRoute
  SessionSession_tokenResultsSplatRoute: typeof SessionSession_tokenResultsSplatRoute
}

const SessionLayoutRouteChildren: SessionLayoutRouteChildren = {
  SessionIndexLazyRoute: SessionIndexLazyRoute,
  SessionSession_tokenIndexRoute: SessionSession_tokenIndexRoute,
  SessionSession_tokenResultsSplatRoute: SessionSession_tokenResultsSplatRoute,
}

const SessionLayoutRouteWithChildren = SessionLayoutRoute._addFileChildren(
  SessionLayoutRouteChildren,
)

interface UserLayoutRouteChildren {
  UserUser_idLazyRoute: typeof UserUser_idLazyRoute
}

const UserLayoutRouteChildren: UserLayoutRouteChildren = {
  UserUser_idLazyRoute: UserUser_idLazyRoute,
}

const UserLayoutRouteWithChildren = UserLayoutRoute._addFileChildren(
  UserLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminLayoutRoute: AdminLayoutRouteWithChildren,
  ParticipateLayoutRoute: ParticipateLayoutRouteWithChildren,
  SessionLayoutRoute: SessionLayoutRouteWithChildren,
  UserLayoutRoute: UserLayoutRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
